<template>
  <v-dialog v-model="value" max-width="600px" persistent>
    <v-card>
      <v-card-title><span class="headline font-weight-thin">Edit Contacts</span> </v-card-title>
      <v-card-text>
        <v-form v-model="valid" ref="form" v-if="serviceAreaRecordClone">
          <br />
          <user-picker
            attributeName="primary-contact"
            :outlined="true"
            label="Primary Contact"
            v-model="serviceAreaRecordClone.contactPrimary"
          ></user-picker>
          <user-picker
            attributeName="secondary-contact"
            :outlined="true"
            label="Secondary Contact"
            v-model="serviceAreaRecordClone.contactSecondary"
          ></user-picker>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn @click="close" data-cy="cancel-button" outlined small>Cancel</v-btn>
            <v-tooltip v-model="show" top v-if="!inputsHaveChanged()">
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn
                    @click="save"
                    :disabled="!valid || !inputsHaveChanged()"
                    class="ml-2"
                    color="primary"
                    data-cy="save-button"
                    outlined
                    small
                    >Save</v-btn
                  >
                </div>
              </template>
              <span>Form cannot be saved unless values have changed.</span>
            </v-tooltip>
            <v-btn
              @click="save"
              :disabled="!valid || !inputsHaveChanged()"
              class="ml-2"
              color="primary"
              data-cy="save-button"
              outlined
              small
              v-else
              >Save</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { cloneDeep } from "lodash";
import { mapActions } from "vuex";
import UserPicker from "@/components/userPicker";

export default {
  components: {
    UserPicker,
  },
  data() {
    return {
      serviceAreaRecordClone: null,
      show: false,
      valid: true,
    };
  },
  methods: {
    inputsHaveChanged() {
      const { contactPrimary, contactSecondary } = this.serviceAreaRecord;
      // Extract usernames from nested objects (or use null if not present)
      const contactPrimaryUsername = contactPrimary?.username || null;
      const contactSecondaryUsername = contactSecondary?.username || null;

      const {
        contactPrimary: contactPrimaryClone,
        contactSecondary: contactSecondaryClone,
      } = this.serviceAreaRecordClone;

      const isDifferent =
        contactPrimaryUsername !== contactPrimaryClone || contactSecondaryUsername !== contactSecondaryClone;

      return isDifferent;
    },
    close() {
      this.$emit("input", false);
    },
    async save() {
      const { id: serviceAreaId } = this.serviceAreaRecord;
      const serviceAreaData = {
        serviceAreaId,
        data: {
          contactPrimary: this.serviceAreaRecordClone.contactPrimary,
          contactSecondary: this.serviceAreaRecordClone.contactSecondary,
        },
      };

      try {
        await this.patchUpdate(serviceAreaData);
        this.$notifySuccess("Successfully updated");
      } catch (e) {
        console.error(e);
        return this.$notifyError("Error updating Organization data");
      }
      this.close();
    },
    ...mapActions({
      loadUserList: "user/load",
      patchUpdate: "admin/serviceArea/patchUpdate",
    }),
  },
  props: {
    serviceAreaRecord: { default: null, required: true, type: Object },
    value: { required: true, type: Boolean },
  },
  watch: {
    value(val) {
      if (val) {
        const cloned = cloneDeep(this.serviceAreaRecord);
        // Extract usernames from nested user objects for form binding
        this.serviceAreaRecordClone = {
          ...cloned,
          contactPrimary: cloned.contactPrimary?.username || null,
          contactSecondary: cloned.contactSecondary?.username || null,
        };
      }
    },
  },
};
</script>
